import { compose, createStore, applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import { autoRehydrate } from 'redux-persist';
import thunkMiddleware from 'redux-thunk';

import rootReducer from './rootReducer';

const loggerMiddleware = createLogger({
  predicate: () => CONFIG.ENV !== 'prod',
});

const composeMiddleware = [
  applyMiddleware(thunkMiddleware),
  applyMiddleware(loggerMiddleware),
  autoRehydrate(),
];

export default createStore(
  rootReducer,
  undefined,
  compose(...composeMiddleware),
);



// WEBPACK FOOTER //
// ./foody/src/redux/store.js